"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _debounce = _interopRequireDefault(require("../debounce"));

var _componentCommon = require("./component-common");

var _errorMessages = _interopRequireDefault(require("./error-messages"));

var _help = _interopRequireDefault(require("./help"));

var _info = _interopRequireDefault(require("./info"));

var _footer = _interopRequireDefault(require("./footer"));

var _row = _interopRequireDefault(require("./row"));

var _textarea = _interopRequireDefault(require("./controls/textarea"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Textarea = /*#__PURE__*/function (_Component) {
  _inherits(Textarea, _Component);

  var _super = _createSuper(Textarea);

  function Textarea(props) {
    var _this;

    _classCallCheck(this, Textarea);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentWillReceiveProps", function (nextProps) {
      var stateValue = _this.state.value;
      var onSetValue = _this.props.onSetValue;
      var isValueChanging = nextProps.value !== stateValue;

      if (isValueChanging) {
        _this.setState({
          value: nextProps.value
        });

        onSetValue(nextProps.value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      var _this$props = _this.props,
          updateOnChange = _this$props.updateOnChange,
          onChange = _this$props.onChange,
          name = _this$props.name;
      var value = event.currentTarget.value;

      _this.setState({
        value: value
      });

      if (updateOnChange) {
        _this.changeDebounced(value);
      }

      onChange(name, value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function (event) {
      var _this$props2 = _this.props,
          updateOnBlur = _this$props2.updateOnBlur,
          onBlur = _this$props2.onBlur,
          name = _this$props2.name;
      var value = event.currentTarget.value;

      _this.setState({
        value: value
      });

      if (updateOnBlur) {
        _this.changeDebounced.cancel();

        _this.blurDebounced(value);
      }

      onBlur(name, value);
    });

    _defineProperty(_assertThisInitialized(_this), "initElementRef", function (control) {
      _this.element = control ? control.element : null;
    });

    var _value = props.value,
        _onSetValue = props.onSetValue,
        changeDebounceInterval = props.changeDebounceInterval,
        blurDebounceInterval = props.blurDebounceInterval;
    _this.state = {
      value: _value
    };
    _this.changeDebounced = (0, _debounce["default"])(_onSetValue, changeDebounceInterval);
    _this.blurDebounced = (0, _debounce["default"])(_onSetValue, blurDebounceInterval);
    return _this;
  }

  _createClass(Textarea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var focusOnMount = this.props.focusOnMount;

      if (focusOnMount) {
        this.element.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var inputProps = Object.assign({}, this.props);
      Object.keys(_componentCommon.componentPropTypes).forEach(function (key) {
        delete inputProps[key];
      });
      delete inputProps.blurDebounceInterval;
      delete inputProps.changeDebounceInterval;
      delete inputProps.updateOnBlur;
      delete inputProps.updateOnChange;
      var value = this.state.value;
      var _this$props3 = this.props,
          layout = _this$props3.layout,
          id = _this$props3.id,
          help = _this$props3.help,
          info = _this$props3.info,
          footer = _this$props3.footer,
          showErrors = _this$props3.showErrors,
          errorMessages = _this$props3.errorMessages;

      var element = /*#__PURE__*/_react["default"].createElement(_textarea["default"], _extends({}, inputProps, {
        value: value,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        ref: this.initElementRef
      }));

      if (layout === 'elementOnly') {
        return element;
      }

      return /*#__PURE__*/_react["default"].createElement(_row["default"], _extends({}, this.props, {
        htmlFor: id
      }), info ? /*#__PURE__*/_react["default"].createElement(_info["default"], {
        info: info
      }) : null, element, footer ? /*#__PURE__*/_react["default"].createElement(_footer["default"], {
        footer: footer
      }) : null, help ? /*#__PURE__*/_react["default"].createElement(_help["default"], {
        help: help
      }) : null, showErrors ? /*#__PURE__*/_react["default"].createElement(_errorMessages["default"], {
        messages: errorMessages
      }) : null);
    }
  }]);

  return Textarea;
}(_react.Component);

Textarea.propTypes = _objectSpread(_objectSpread(_objectSpread({}, _componentCommon.componentPropTypes), _textarea["default"].propTypes), {}, {
  blurDebounceInterval: _propTypes["default"].number,
  changeDebounceInterval: _propTypes["default"].number,
  updateOnBlur: _propTypes["default"].bool,
  updateOnChange: _propTypes["default"].bool,
  focusOnMount: _propTypes["default"].bool,
  value: _propTypes["default"].string,
  onBlur: _propTypes["default"].func
});
Textarea.defaultProps = _objectSpread(_objectSpread({}, _componentCommon.componentDefaultProps), {}, {
  updateOnBlur: true,
  updateOnChange: true,
  blurDebounceInterval: 0,
  changeDebounceInterval: 500,
  focusOnMount: false,
  onBlur: function onBlur() {}
});
var _default = Textarea;
exports["default"] = _default;